import type { PageTemplateProps } from "./pageTemplateTypes";

/**
 * Slot-driven React template for the catch-all Simple Content page whose
 * backend {@code metadata.templateUid} is {@code "SimpleContentPageTemplate"}
 * (legacy {@code layout/simpleContentPage.jsp}).
 *
 * Structure-copy parity of {@code simpleContentPage.jsp}: the {@code BannerSlot}
 * inside a {@code #banner} wrapper followed by the {@code ParagraphSlot} inside a
 * {@code #paragraph} wrapper. Both slots are placed to mirror the JSP, even when
 * one is currently unpopulated, so content is never silently dropped.
 *
 * Catch-all simple-content pages (e.g. {@code /termsAndConditions}) have no React
 * island, so {@code body} is null.
 */
export function SimpleContentPageTemplate({ slots, body }: PageTemplateProps) {
  return (
    <>
      <div id="banner">{slots.renderSlot("BannerSlot")}</div>
      <div id="paragraph">{slots.renderSlot("ParagraphSlot")}</div>
      {body}
    </>
  );
}
